import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var res;
export const visitorListTodo = createAsyncThunk('visitorList', async (data) => {
    const { navigate, params } = data || {};
    // console.log(params)
    try {
        const query = new URLSearchParams(params || {}).toString();
        const url = process.env.REACT_APP_API_URL + `visitors${query ? `?${query}` : ''}`;
        const res = await axios({
            method: "get",
            url,
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') },
        })

        return res

    } catch (error) {
        return error?.response
    }
});

const visitorListSlice = createSlice({
    name: 'visitorList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(visitorListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status == 401) {
                localStorage.clear();
                action?.meta?.arg?.navigate && action?.meta?.arg?.navigate('../login')
            } else {
                state.data = []
            }
        });
        builder.addCase(visitorListTodo.rejected, (state, action) => {
        })
    }
});

export default visitorListSlice.reducer;


